// ── Tension bag: shuffle and draw logic ──

/** Create a shuffled tension bag: 9×1, 9×2, 9×3 */
export function createShuffledBag(): number[] {
  const tokens: number[] = [];
  for (let v = 1; v <= 3; v++) {
    for (let i = 0; i < 9; i++) {
      tokens.push(v);
    }
  }
  // Fisher-Yates shuffle
  for (let i = tokens.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [tokens[i], tokens[j]] = [tokens[j], tokens[i]];
  }
  return tokens;
}

/** Draw the next pair of tokens from the bag sequence.
 *  If only one token remains, returns it as both token1 and token2
 *  (player has no choice but to keep it). */
export function drawPair(
  sequence: number[],
  drawIndex: number,
): { token1: number; token2: number; nextIndex: number } | null {
  if (drawIndex >= sequence.length) return null;
  if (drawIndex + 1 >= sequence.length) {
    // Only one token left — forced choice
    return {
      token1: sequence[drawIndex],
      token2: sequence[drawIndex],
      nextIndex: drawIndex + 1,
    };
  }
  return {
    token1: sequence[drawIndex],
    token2: sequence[drawIndex + 1],
    nextIndex: drawIndex + 2,
  };
}

/** Check if the bag has enough tokens for another draw */
export function canDraw(sequence: number[], drawIndex: number): boolean {
  return drawIndex + 1 < sequence.length;
}

/** Count remaining tokens in the bag (undrawn) */
export function remainingTokens(sequence: number[], drawIndex: number): number {
  return sequence.length - drawIndex;
}
